import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

// Type for the plan creation payload
type UpdatePlanFeaturePayload = {
    plan_feature_id: string;
    plan_id: string;
    feature_id: string;
    value: string;
};

// Mutation function that calls the API
export const updateFeaturePlan = async (payload: UpdatePlanFeaturePayload) => {
    const { plan_feature_id, ...rest } = payload;
    try {
        const response = await Axios.put(`/plan_feature/${plan_feature_id}`, rest);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

// Custom hook for creating a plan
export const useUpdatePlanFeature = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: UpdatePlanFeaturePayload) => updateFeaturePlan(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["get-feature-plan"] }); // Adjust query key if needed
            queryClient.refetchQueries({ queryKey: ["get-plan"] }); // Adjust query key if needed
            toast.success("Plan feature updated successfully.");
            console.log({ data });
        },
        onError: (error: Error) => {
            toast.error("Unable to create plan.", { description: error.message });
            console.error({ error });
        },
    });
};
